import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser, registerUser, clearAuthMessages, verifyOtp, checkTokenExpiry } from '../redux/Slices/authSlice';
import logo from '../../components/assets/logos/logo2.PNG';
import Busimg from '../../components/assets/bus.jpg';
import toast from 'react-hot-toast';

// --- Responsive Styles with Yellow Theme ---
const responsiveStyles = {
  landingPage: {
    display: 'flex',
    flexDirection: 'row',
    background: '#FFFFFF',
    overflow: 'hidden',
    height: '100vh',
  },

  frame1: {
    width: '45%',
    minWidth: '400px',
    background: 'linear-gradient(135deg, #FFF9C4 0%, #FFFDE7 100%)',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    position: 'relative',
    boxSizing: 'border-box',
  },

  logoContainer: {
    width: 'min(50%, 250px)',
    marginBottom: '20px',
  },

  logoImage: {
    width: '100%',
    height: 'auto',
    display: 'block',
    filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.1))',
  },

  welcomeText: {
    fontFamily: "'Noto Serif Devanagari', serif",
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: 'min(4vw, 30px)',
    lineHeight: '1.3',
    textAlign: 'center',
    color: '#5D4037',
    padding: '0 5%',
    flexGrow: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '80%',
    textShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
  },

  busImageContainer: {
    flexGrow: 1,
    height: '100%',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    background: '#FFFDE7',
  },

  busImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
    opacity: '0.9',
  },

  authCard: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '410px',
    backgroundColor: 'white',
    boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.15), 0px 4px 12px rgba(255, 193, 7, 0.1)',
    borderRadius: '28.4583px',
    padding: '40px 80px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: '1px solid rgba(255, 235, 59, 0.3)',
  },

  authCardContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    width: '250px',
  },

  authTitle: {
    fontFamily: "'Noto Serif Devanagari', serif",
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '30px',
    color: '#5D4037',
    textShadow: '0px 1px 1px rgba(0, 0, 0, 0.05)',
  },

  authForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%',
  },

  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px',
    gap: '8px',
    width: '100%',
  },

  label: {
    fontFamily: "'Noto Serif Devanagari', serif",
    fontWeight: '500',
    fontSize: '13px',
    lineHeight: '16px',
    color: '#5D4037',
    marginLeft: '4px',
  },

  inputFrame: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0 16px',
    gap: '10px',
    width: '100%',
    height: '38px',
    background: '#FFFFFF',
    border: '1px solid #000000',
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.05)',
  },

  otpInputFrame: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    width: '100%',
    marginBottom: '10px',
  },

  otpInput: {
    width: '50px',
    height: '50px',
    textAlign: 'center',
    fontSize: '24px',
    fontWeight: '600',
    border: '2px solid #FFD54F',
    borderRadius: '8px',
    outline: 'none',
    transition: 'all 0.3s ease',
    backgroundColor: '#FFFFFF',
    color: '#5D4037',
  },

  timerText: {
    fontFamily: "'Noto Serif Devanagari', serif",
    fontSize: '12px',
    color: '#FF9800',
    textAlign: 'center',
    marginTop: '8px',
  },

  resendButton: {
    background: 'none',
    border: 'none',
    color: '#FF9800',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '600',
    textDecoration: 'underline',
    marginTop: '5px',
    fontFamily: "'Noto Serif Devanagari', serif",
  },

  inputField: {
    flexGrow: 1,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    padding: '0',
    margin: '0',
    fontFamily: "'Noto Serif Devanagari', serif",
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#000000',
  },

  placeholderText: {
    color: '#A1887F',
  },

  passwordFrame: {
    justifyContent: 'space-between',
  },

  eyeIcon: {
    color: '#FFC107',
    fontSize: '16px',
    cursor: 'pointer',
    width: '20px',
    height: '20px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'color 0.2s ease',
  },

  eyeIconHover: {
    color: '#FF8F00',
  },

  authButton: {
    width: '100%',
    height: '44px',
    background: 'linear-gradient(145deg, #FFEB3B 0%, #FFD54F 100%)',
    borderRadius: '10px',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.3s ease',
    marginTop: '10px',
    boxShadow: '0 4px 12px rgba(255, 193, 7, 0.3), 0 0 8px rgba(255, 235, 59, 0.4)',
    position: 'relative',
    overflow: 'hidden',
  },

  authButtonHover: {
    background: 'linear-gradient(145deg, #FFD54F 0%, #FFC107 100%)',
    boxShadow: '0 6px 20px rgba(255, 193, 7, 0.4), 0 0 12px rgba(255, 235, 59, 0.6)',
    transform: 'translateY(-2px)',
  },

  authButtonActive: {
    transform: 'translateY(0) scale(0.98)',
    boxShadow: '0 2px 8px rgba(255, 193, 7, 0.2)',
  },

  authButtonText: {
    fontFamily: "'Noto Serif Devanagari', serif",
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '20px',
    color: '#5D4037',
    letterSpacing: '0.5px',
    textShadow: '0px 1px 1px rgba(255, 255, 255, 0.5)',
  },

  toggleText: {
    width: '100%',
    textAlign: 'center',
    fontFamily: "'Noto Serif Devanagari', serif",
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#5D4037',
    marginTop: '10px',
  },

  toggleLink: {
    color: '#FF9800',
    textDecoration: 'none',
    fontWeight: '600',
    cursor: 'pointer',
    marginLeft: '5px',
    transition: 'color 0.2s ease',
  },

  toggleLinkHover: {
    color: '#FF5722',
    textDecoration: 'underline',
  },

  errorMessage: {
    color: '#D32F2F',
    fontSize: '13px',
    fontFamily: "'Noto Serif Devanagari', serif",
    textAlign: 'center',
    padding: '8px 12px',
    backgroundColor: 'rgba(211, 47, 47, 0.1)',
    borderRadius: '6px',
    border: '1px solid rgba(211, 47, 47, 0.2)',
    width: '100%',
  },
  
  successMessage: {
    color: '#2E7D32',
    fontSize: '13px',
    fontFamily: "'Noto Serif Devanagari', serif",
    textAlign: 'center',
    padding: '8px 12px',
    backgroundColor: 'rgba(46, 125, 50, 0.1)',
    borderRadius: '6px',
    border: '1px solid rgba(46, 125, 50, 0.2)',
    width: '100%',
  },
  
  decorativeCorner: {
    position: 'absolute',
    top: '0',
    right: '0',
    width: '100px',
    height: '100px',
    background: 'radial-gradient(circle at top right, #FFEB3B 0%, transparent 70%)',
    opacity: '0.15',
    borderRadius: '0 28px 0 0',
  },

  backButton: {
    background: 'none',
    border: 'none',
    color: '#FF9800',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    fontFamily: "'Noto Serif Devanagari', serif",
  }
};

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  
  const { loading, error, success, user } = useSelector((state) => state.auth);

  // Local State for Form Inputs and UI Toggles
  const [isRegister, setIsRegister] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isButtonHovered, setIsButtonHovered] = useState(false);
  const [isButtonActive, setIsButtonActive] = useState(false);
  const [isEyeHovered, setIsEyeHovered] = useState(false);
  const [isToggleHovered, setIsToggleHovered] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [activeInput, setActiveInput] = useState('');

  // OTP related state
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [otpCode, setOtpCode] = useState(['', '', '', '']);
  const [timer, setTimer] = useState(300);
  const [canResendOtp, setCanResendOtp] = useState(false);
  const [tempUserData, setTempUserData] = useState(null);

  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  });

  const [registerData, setRegisterData] = useState({
    fullName: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  // Check token expiry on mount
  useEffect(() => {
    dispatch(checkTokenExpiry());
    
    const checkInterval = setInterval(() => {
      dispatch(checkTokenExpiry());
    }, 60000);
    
    return () => clearInterval(checkInterval);
  }, [dispatch]);

  // Timer effect for OTP
  useEffect(() => {
    let interval = null;
    if (showOtpScreen && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(interval);
            setCanResendOtp(true);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [showOtpScreen, timer]);

  // FIXED: Handles navigation after successful login - supports role as array or string
  useEffect(() => {
    if (user && user.role) {
      console.log(user);
      
      let roleString = '';
      if (Array.isArray(user.role)) {
        roleString = user.role[0] || '';
      } else if (typeof user.role === 'string') {
        roleString = user.role;
      } else {
        roleString = '';
      }
      
      const lowerRole = roleString.toLowerCase();
      switch (lowerRole) {
        case 'admin':
        case 'superadmin':
          navigate('/dashboard');
          break;
        case 'driver':
          navigate('/driver-dashboard');
          break;
        case 'conductor':
          navigate('/conductor-dashboard');
          break;
        default:
          navigate('/dashboard');
      }
    }
  }, [user, navigate]);

  // Clears Redux messages when switching auth mode
  useEffect(() => {
    dispatch(clearAuthMessages());
  }, [isRegister, dispatch]);

  // Handle login submission
  const handleLogin = async (e) => {
    e.preventDefault();
    dispatch(clearAuthMessages());
    
    const result = await dispatch(loginUser(loginData));
    
    if (loginUser.fulfilled.match(result)) {
      if (result.payload?.requiresOtp) {
        toast.success(result.payload.message || 'OTP sent to your email');
        setTempUserData({
          email: loginData.email,
          password: loginData.password,
          userId: result.payload.userId
        });
        setShowOtpScreen(true);
        setTimer(300);
        setCanResendOtp(false);
        setOtpCode(['', '', '', '']);
      } else {
        toast.success('Login successful!');
      }
    } else if (loginUser.rejected.match(result)) {
      toast.error(result.payload || 'Login failed');
    }
  };

  // Handle OTP verification
  const handleVerifyOtp = async () => {
    const otp = otpCode.join('');
    if (otp.length !== 4) {
      toast.error('Please enter a valid 4-digit OTP');
      return;
    }

    const result = await dispatch(verifyOtp({
      email: tempUserData.email,
      password: tempUserData.password,
      otp: otp
    }));

    if (verifyOtp.fulfilled.match(result)) {
      toast.success('Login successful!');
      setShowOtpScreen(false);
    } else if (verifyOtp.rejected.match(result)) {
      toast.error(result.payload || 'OTP verification failed');
      setOtpCode(['', '', '', '']);
      setTimeout(() => {
        const firstInput = document.getElementById('otp-input-0');
        if (firstInput) firstInput.focus();
      }, 100);
    }
  };

  // Handle resend OTP
  const handleResendOtp = async () => {
    if (!canResendOtp) {
      toast.error('Please wait for 5 minutes before resending OTP');
      return;
    }
    
    const result = await dispatch(loginUser({
      email: tempUserData.email,
      password: tempUserData.password
    }));
    
    if (loginUser.fulfilled.match(result) && result.payload?.requiresOtp) {
      toast.success('OTP resent successfully');
      setTimer(300);
      setCanResendOtp(false);
      setOtpCode(['', '', '', '']);
      setTimeout(() => {
        const firstInput = document.getElementById('otp-input-0');
        if (firstInput) firstInput.focus();
      }, 100);
    } else if (loginUser.rejected.match(result)) {
      toast.error(result.payload || 'Failed to resend OTP');
    }
  };

  // Handle OTP input change
  const handleOtpChange = (index, value) => {
    if (value.length > 1) return;
    if (!/^\d*$/.test(value)) return;
    
    const newOtp = [...otpCode];
    newOtp[index] = value;
    setOtpCode(newOtp);
    
    if (value && index < 3) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  // Handle OTP key press
  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otpCode[index] && index > 0) {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  // Format timer display
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Handle back to login
  const handleBackToLogin = () => {
    setShowOtpScreen(false);
    setTempUserData(null);
    setOtpCode(['', '', '', '']);
    setTimer(300);
    setCanResendOtp(false);
    dispatch(clearAuthMessages());
  };

  // Updated registration submission for new API
  const handleRegister = async (e) => {
    e.preventDefault();
    dispatch(clearAuthMessages());

    if (registerData.password !== registerData.confirmPassword) {
      const errorMsg = t('passwordMismatch', 'Passwords do not match.');
      dispatch({ type: 'auth/registerUser/rejected', payload: errorMsg });
      toast.error(errorMsg);
      return;
    }

    if (registerData.password.length < 6) {
      toast.error('Password must be at least 6 characters long');
      return;
    }

    const registrationPayload = {
      fullName: registerData.fullName,
      email: registerData.email,
      password: registerData.password
    };

    const resultAction = await dispatch(registerUser(registrationPayload));

    if (registerUser.fulfilled.match(resultAction)) {
      toast.success('Registration successful! Please login with your credentials.');
      setLoginData(prev => ({
        ...prev,
        email: registerData.email
      }));
      
      setRegisterData({
        fullName: '',
        email: '',
        password: '',
        confirmPassword: ''
      });
      
      setTimeout(() => {
        setIsRegister(false);
        dispatch(clearAuthMessages());
      }, 2000);
    } else if (registerUser.rejected.match(resultAction)) {
      toast.error(resultAction.payload || 'Registration failed');
    }
  };

  // Handle input changes for login
  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle input changes for registration
  const handleRegisterChange = (e) => {
    const { name, value } = e.target;
    setRegisterData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Toggle between login and register
  const toggleAuthMode = () => {
    setIsRegister(!isRegister);
    dispatch(clearAuthMessages());
  };

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Toggle confirm password visibility
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  // Handle input focus
  const handleInputFocus = (fieldName) => {
    setActiveInput(fieldName);
    setIsInputFocused(true);
  };

  // Handle input blur
  const handleInputBlur = () => {
    setActiveInput('');
    setIsInputFocused(false);
  };

  // Calculate button style
  const buttonStyle = {
    ...responsiveStyles.authButton,
    ...(isButtonHovered ? responsiveStyles.authButtonHover : {}),
    ...(isButtonActive ? responsiveStyles.authButtonActive : {})
  };

  // Calculate eye icon style
  const eyeIconStyle = {
    ...responsiveStyles.eyeIcon,
    ...(isEyeHovered ? responsiveStyles.eyeIconHover : {})
  };

  // Calculate toggle link style
  const toggleLinkStyle = {
    ...responsiveStyles.toggleLink,
    ...(isToggleHovered ? responsiveStyles.toggleLinkHover : {})
  };

  // Calculate input frame style
  const inputFrameStyle = {
    ...responsiveStyles.inputFrame,
    ...(isInputFocused ? responsiveStyles.inputFrameFocus : {})
  };

  // Calculate input field style
  const getInputFieldStyle = (hasValue) => {
    return {
      ...responsiveStyles.inputField,
      ...(!hasValue ? responsiveStyles.placeholderText : {}),
    };
  };

  // Get placeholder text based on language
  const getPlaceholder = (field) => {
    if (i18n.language === 'hi') {
      switch(field) {
        case 'fullName': return 'पूरा नाम';
        case 'email': return 'ईमेल';
        case 'password': return 'पासवर्ड';
        case 'confirmPassword': return 'पासवर्ड की पुष्टि करें';
        default: return '';
      }
    }
    return {
      'fullName': 'John Doe',
      'email': 'username@gmail.com',
      'password': 'Password',
      'confirmPassword': 'Confirm Password'
    }[field];
  };

  // If OTP screen is shown, render OTP verification UI
  if (showOtpScreen) {
    return (
      <div style={responsiveStyles.landingPage}>
        <div style={responsiveStyles.frame1}>
          <div style={responsiveStyles.decorativeCorner}></div>
          <div style={responsiveStyles.logoContainer}>
            <img src={logo} alt={t('logoAlt', 'Rajdoot Logo')} style={responsiveStyles.logoImage} />
          </div>
          <div style={responsiveStyles.welcomeText}>
            {t('welcomeMessageLogin', 'WELCOME TO THE RAJDOOT TRANSPORT MANAGEMENT SYSTEM')}
          </div>
        </div>

        <div style={responsiveStyles.busImageContainer}>
          <img src={Busimg} alt={t('busImageAlt', 'Bus background')} style={responsiveStyles.busImage} />

          <div style={responsiveStyles.authCard}>
            <div style={responsiveStyles.authCardContent}>
              <button onClick={handleBackToLogin} style={responsiveStyles.backButton}>
                ← {t('backToLogin', 'Back to Login')}
              </button>
              
              <div style={responsiveStyles.authTitle}>
                {t('verifyOtp', 'Verify OTP')}
              </div>

              {error && (
                <div style={responsiveStyles.errorMessage}>
                  {error}
                </div>
              )}

              {success && !error && (
                <div style={responsiveStyles.successMessage}>
                  {success}
                </div>
              )}

              <div style={responsiveStyles.inputGroup}>
                <label style={responsiveStyles.label}>
                  {t('enterOtp', 'Enter 4-digit OTP')}
                </label>
                <div style={responsiveStyles.otpInputFrame}>
                  {[0, 1, 2, 3].map((index) => (
                    <input
                      key={index}
                      id={`otp-input-${index}`}
                      type="text"
                      maxLength="1"
                      value={otpCode[index]}
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                      onKeyDown={(e) => handleOtpKeyDown(index, e)}
                      style={responsiveStyles.otpInput}
                      autoFocus={index === 0}
                    />
                  ))}
                </div>
                
                <div style={responsiveStyles.timerText}>
                  {timer > 0 ? (
                    `OTP valid for: ${formatTime(timer)}`
                  ) : (
                    'OTP has expired'
                  )}
                </div>
                
                {canResendOtp && (
                  <button
                    onClick={handleResendOtp}
                    style={responsiveStyles.resendButton}
                    disabled={loading}
                  >
                    {loading ? t('sending', 'Sending...') : t('resendOtp', 'Resend OTP')}
                  </button>
                )}
              </div>

              <button
                onClick={handleVerifyOtp}
                style={buttonStyle}
                disabled={loading || otpCode.join('').length !== 4}
                onMouseEnter={() => setIsButtonHovered(true)}
                onMouseLeave={() => {
                  setIsButtonHovered(false);
                  setIsButtonActive(false);
                }}
                onMouseDown={() => setIsButtonActive(true)}
                onMouseUp={() => setIsButtonActive(false)}
              >
                <div style={responsiveStyles.authButtonText}>
                  {loading ? t('verifying', 'Verifying...') : t('verify', 'Verify')}
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={responsiveStyles.landingPage}>
      {/* Left Sidebar */}
      <div style={responsiveStyles.frame1}>
        <div style={responsiveStyles.decorativeCorner}></div>
        <div style={responsiveStyles.logoContainer} role="img" aria-label="Rajdoot Logo">
          <img
            src={logo}
            alt={t('logoAlt', 'Rajdoot Logo')}
            style={responsiveStyles.logoImage}
          />
        </div>

        <div style={responsiveStyles.welcomeText}>
          {t('welcomeMessageLogin', 'WELCOME TO THE RAJDOOT TRANSPORT MANAGEMENT SYSTEM')}
        </div>
      </div>

      {/* Right Side: Bus Image and Auth Card */}
      <div style={responsiveStyles.busImageContainer} role="img" aria-label="Bus image background">
        <img
          src={Busimg}
          alt={t('busImageAlt', 'Bus background')}
          style={responsiveStyles.busImage}
        />

        {/* Auth Card (Centered) */}
        <div style={responsiveStyles.authCard}>
          <div style={responsiveStyles.authCardContent}>
            <div style={responsiveStyles.authTitle}>
              {isRegister ? t('register', 'Register') : t('login', 'Login')}
            </div>

            {error && (
              <div style={responsiveStyles.errorMessage}>
                {error}
              </div>
            )}

            {success && !error && (
              <div style={responsiveStyles.successMessage}>
                {success}
              </div>
            )}

            {isRegister ? (
              <form onSubmit={handleRegister} style={responsiveStyles.authForm}>
                <div style={responsiveStyles.inputGroup}>
                  <label htmlFor="fullName" style={responsiveStyles.label}>
                    {t('fullName', 'Full Name')}
                  </label>
                  <div style={inputFrameStyle}>
                    <input
                      type="text"
                      id="fullName"
                      name="fullName"
                      value={registerData.fullName}
                      onChange={handleRegisterChange}
                      placeholder={getPlaceholder('fullName')}
                      style={getInputFieldStyle(registerData.fullName.length > 0)}
                      required
                      onFocus={() => handleInputFocus('fullName')}
                      onBlur={handleInputBlur}
                    />
                  </div>
                </div>

                <div style={responsiveStyles.inputGroup}>
                  <label htmlFor="email" style={responsiveStyles.label}>
                    {t('email', 'Email')}
                  </label>
                  <div style={inputFrameStyle}>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={registerData.email}
                      onChange={handleRegisterChange}
                      placeholder={getPlaceholder('email')}
                      style={getInputFieldStyle(registerData.email.length > 0)}
                      required
                      onFocus={() => handleInputFocus('email')}
                      onBlur={handleInputBlur}
                    />
                  </div>
                </div>

                <div style={responsiveStyles.inputGroup}>
                  <label htmlFor="password" style={responsiveStyles.label}>
                    {t('password', 'Password')}
                  </label>
                  <div style={{ ...inputFrameStyle, ...responsiveStyles.passwordFrame }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      value={registerData.password}
                      onChange={handleRegisterChange}
                      placeholder={getPlaceholder('password')}
                      style={getInputFieldStyle(registerData.password.length > 0)}
                      required
                      minLength="6"
                      onFocus={() => handleInputFocus('password')}
                      onBlur={handleInputBlur}
                    />
                    <span 
                      onClick={togglePasswordVisibility} 
                      style={eyeIconStyle}
                      onMouseEnter={() => setIsEyeHovered(true)}
                      onMouseLeave={() => setIsEyeHovered(false)}
                      title={showPassword ? t('hidePassword', 'Hide password') : t('showPassword', 'Show password')}
                    >
                      {showPassword ? '🙈' : '👁'}
                    </span>
                  </div>
                </div>

                <div style={responsiveStyles.inputGroup}>
                  <label htmlFor="confirmPassword" style={responsiveStyles.label}>
                    {t('confirmPassword', 'Confirm Password')}
                  </label>
                  <div style={{ ...inputFrameStyle, ...responsiveStyles.passwordFrame }}>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      id="confirmPassword"
                      name="confirmPassword"
                      value={registerData.confirmPassword}
                      onChange={handleRegisterChange}
                      placeholder={getPlaceholder('confirmPassword')}
                      style={getInputFieldStyle(registerData.confirmPassword.length > 0)}
                      required
                      onFocus={() => handleInputFocus('confirmPassword')}
                      onBlur={handleInputBlur}
                    />
                    <span 
                      onClick={toggleConfirmPasswordVisibility} 
                      style={eyeIconStyle}
                      onMouseEnter={() => setIsEyeHovered(true)}
                      onMouseLeave={() => setIsEyeHovered(false)}
                      title={showConfirmPassword ? t('hidePassword', 'Hide password') : t('showPassword', 'Show password')}
                    >
                      {showConfirmPassword ? '🙈' : '👁'}
                    </span>
                  </div>
                </div>

                <button 
                  type="submit" 
                  style={buttonStyle} 
                  disabled={loading}
                  onMouseEnter={() => setIsButtonHovered(true)}
                  onMouseLeave={() => {
                    setIsButtonHovered(false);
                    setIsButtonActive(false);
                  }}
                  onMouseDown={() => setIsButtonActive(true)}
                  onMouseUp={() => setIsButtonActive(false)}
                  onTouchStart={() => setIsButtonActive(true)}
                  onTouchEnd={() => setIsButtonActive(false)}
                >
                  <div style={responsiveStyles.authButtonText}>
                    {loading ? t('registering', 'Registering...') : t('register', 'Register')}
                  </div>
                </button>
              </form>
            ) : (
              <form onSubmit={handleLogin} style={responsiveStyles.authForm}>
                <div style={responsiveStyles.inputGroup}>
                  <label htmlFor="loginEmail" style={responsiveStyles.label}>
                    {t('email', 'Email')}
                  </label>
                  <div style={inputFrameStyle}>
                    <input
                      type="email"
                      id="loginEmail"
                      name="email"
                      value={loginData.email}
                      onChange={handleLoginChange}
                      placeholder={getPlaceholder('email')}
                      style={getInputFieldStyle(loginData.email.length > 0)}
                      required
                      onFocus={() => handleInputFocus('loginEmail')}
                      onBlur={handleInputBlur}
                    />
                  </div>
                </div>

                <div style={responsiveStyles.inputGroup}>
                  <label htmlFor="loginPassword" style={responsiveStyles.label}>
                    {t('password', 'Password')}
                  </label>
                  <div style={{ ...inputFrameStyle, ...responsiveStyles.passwordFrame }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      id="loginPassword"
                      name="password"
                      value={loginData.password}
                      onChange={handleLoginChange}
                      placeholder={getPlaceholder('password')}
                      style={getInputFieldStyle(loginData.password.length > 0)}
                      required
                      onFocus={() => handleInputFocus('loginPassword')}
                      onBlur={handleInputBlur}
                    />
                    <span 
                      onClick={togglePasswordVisibility} 
                      style={eyeIconStyle}
                      onMouseEnter={() => setIsEyeHovered(true)}
                      onMouseLeave={() => setIsEyeHovered(false)}
                      title={showPassword ? t('hidePassword', 'Hide password') : t('showPassword', 'Show password')}
                    >
                      {showPassword ? '🙈' : '👁'}
                    </span>
                  </div>
                </div>

                <button 
                  type="submit" 
                  style={buttonStyle} 
                  disabled={loading}
                  onMouseEnter={() => setIsButtonHovered(true)}
                  onMouseLeave={() => {
                    setIsButtonHovered(false);
                    setIsButtonActive(false);
                  }}
                  onMouseDown={() => setIsButtonActive(true)}
                  onMouseUp={() => setIsButtonActive(false)}
                  onTouchStart={() => setIsButtonActive(true)}
                  onTouchEnd={() => setIsButtonActive(false)}
                >
                  <div style={responsiveStyles.authButtonText}>
                    {loading ? t('signingIn', 'Signing in...') : t('signIn', 'Sign in')}
                  </div>
                </button>
              </form>
            )}

            {/* Toggle link (commented out as in original) */}
            {/* <div style={responsiveStyles.toggleText}>
              {isRegister ? t('alreadyHaveAccount', 'Already have an account?') : t('noAccount', "Don't have an account yet?")}
              <span 
                onClick={toggleAuthMode} 
                style={toggleLinkStyle}
                onMouseEnter={() => setIsToggleHovered(true)}
                onMouseLeave={() => setIsToggleHovered(false)}
              >
                {isRegister ? ` ${t('login', 'Login')}` : ` ${t('registerForFree', 'Register for free')}`}
              </span>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;